module.exports = __webpack_public_path__ + "assets/webgl/LM_1_2.jpg.9f3fc791.webp";